






import videojs, { VideoJsPlayer } from 'video.js'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class AudioPlayer extends Vue {
  @Prop() src!:any

  player: VideoJsPlayer | null = null

  mounted () {
    this.player = videojs(this.$refs.audioPlayer, {
      // poster: "/img/audioPoster.jpg",
      controls: true,
      autoplay: false,
      fluid: true,
      preload: 'auto',
      width: 100,
      height: 35, // 280,
      techOrder: ['html5', 'flash', 'aurora']
    }, function () {
    })
  }

  beforeDestroy () {
    if (this.player) {
      this.player.dispose()
    }
  }
}
